import CardDesignerCardElementPhoto from './CardDesignerCardElementPhoto';

export default CardDesignerCardElementPhoto;
